export default "__VITE_ASSET__DvGal1Rh__"